<template>
  <h1>Heat Map</h1>
</template>

<script>
export default {
  name: 'ClientSummary',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

</style>
